// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-card--back[data-v-6adfe82e] {\n  border-radius: 16px;\n  height: 100%;\n  overflow-y: auto;\n}\n.c-card--reveal[data-v-6adfe82e] {\n  top: 0;\n  opacity: 1 !important;\n  position: absolute;\n  width: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
